var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M24 10a8 8 0 014.254 14.776l-.143-.037C33.275 26.025 37 29.672 37 33.97c0 5.373-26 5.373-26 0 0-4.258 3.655-7.877 8.746-9.195A8 8 0 0124 10zm4.062 14.895l-.16.09A7.964 7.964 0 0124 26a7.963 7.963 0 01-4.06-1.105c.02.053.044.105.072.155l2.943 5.206a1.2 1.2 0 002.09 0l2.943-5.206a1.21 1.21 0 00.074-.155z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
